import { render } from "./Joinlink.vue?vue&type=template&id=c04d0b64&scoped=true"
import script from "./Joinlink.vue?vue&type=script&lang=js"
export * from "./Joinlink.vue?vue&type=script&lang=js"

import "./Joinlink.vue?vue&type=style&index=0&id=c04d0b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04d0b64"]])

export default __exports__